import React, { createContext, useState, useContext, useCallback } from 'react'
import { Dialog, DialogActions, Button, DialogTitle } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { employerSide } from './routerHistory'

const NavigationPromptContext = createContext()

export const useNavigationPrompt = () => useContext(NavigationPromptContext)

export const NavigationPromptProvider = ({ children }) => {
  const { t } = useTranslation()
  const [shouldBlock, setShouldBlock] = useState(false)
  const [message, setMessage] = useState('')
  //   const [nextLocation, setNextLocation] = useState(null)
  const [onConfirm, setOnConfirm] = useState(() => () => {})

  const confirmAction = useCallback(
    (location, callback) => {
      setMessage(t('openForWork.warn1'))
      // setNextLocation(location)
      setShouldBlock(true)
      setOnConfirm(() => () => {
        callback()
        setShouldBlock(false)
      })
    },
    [t]
  )

  const handleClose = () => {
    setShouldBlock(false)
    // setNextLocation(null)
  }

  const handleConfirm = () => {
    onConfirm()
  }

  return (
    <NavigationPromptContext.Provider value={{ confirmAction }}>
      {children}
      <Dialog open={shouldBlock}>
        <DialogTitle>
          <span>{message}</span>
        </DialogTitle>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={handleClose}
            style={{ fontSize: '13px' }}
          >
            {!employerSide
              ? t('decisionDialog.cancelButton')
              : t('employer.decisionDialog.cancelButton')}
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirm}
            style={{ fontSize: '13px' }}
          >
            {!employerSide
              ? t('decisionDialog.dialogBtn2')
              : t('employer.decisionDialog.dialogBtn2')}
          </Button>
        </DialogActions>
      </Dialog>
    </NavigationPromptContext.Provider>
  )
}
